<template>
  <div class="unlock_card" :class="[props.theme]" v-if="isShow">
    <div class="gradient"></div>
    <!--    会员解锁    -->
    <div class="unlock_content" v-if="monetization !==3">
      <img
          v-if="!props.isAds"
          src="~/assets/images/reader/icon-reader-thank.png"
          alt=""
      >
      <img v-else src="~/assets/images/me/icon-me-crown.png" alt=""/>
      <span v-if="!props.isAds">{{ $t('reader.thank_you') }}</span>
      <p v-if="!props.isAds">{{ $t('reader.show_your_support') }}</p>
      <p v-else class="ads_p">{{ $t('reader.ads_show_your_support') }}</p>
      <!--   非落地页   -->
      <div class="unlock_btn" v-if="!props.isAds">
        <!--    会员解锁    -->
        <div @click="showProductPopup" v-if="!isLoading">
          {{ unlockCoin }} {{ $t('reader.coins_to_read') }}
          <img
              class="point_img"
              src="~/assets/images/reader/icon-reader-pointer.gif"
              alt=""
          >
        </div>
        <div v-else>
          <van-loading size="20"/>
        </div>
      </div>
      <!--   落地页   -->
      <div class="unlock_btn" v-else>
        <!--    会员解锁    -->
        <div @click="showProductPopup" v-if="!isLoading">
          {{ $t('reader.ads_subscribe_now') }}
          <img
              class="point_img"
              src="~/assets/images/reader/icon-reader-pointer.gif"
              alt=""
          >
        </div>
        <div v-else>
          <van-loading size="20"/>
        </div>
        <!--    角标    -->
        <div class="ads_badge">
          <img src="~/assets/images/me/icon-me-q.svg" alt=""/>
          <p class="ads_badge_off_text">50% Off for New User</p>
        </div>
      </div>
      <p v-if="!props.isAds">
        {{ $t('reader.coins_balance') }} {{ userBalance.balance }}
        {{ $t('reader.coins') }}
      </p>
    </div>
    <!--    金币解锁 (新样式)    -->
    <div class="unlock_content"  style="width: 100%;" v-else>
      <img src="~/assets/images/common/icon-common-lock.svg" alt="" style="width: 23px;margin-bottom: 10px">
      <p style="color: #222222;font-weight: 600;font-size: 17px;">{{$t('reader.unlock_to_support_author')}}</p>
      <div class="unlock_btn"  style="width: 100%;" @click="showProductPopup">
        <!--    会员解锁    -->
        <div  v-if="!isLoading">
          {{ $t('reader.unlock_now') }}
        </div>
        <div v-if="isLoading">
          <van-loading size="20"/>
        </div>
      </div>
      <p @click="showProductPopup" style="color:#FF1979">{{$t('reader.unlock_all_chapters')}}></p>
    </div>
    <!--    V2.3.0 金币档位条：关闭浮层/挽留且未创建订单后触发显示，点击打开充值浮层    -->
    <div class="coin_tier" :class="{ coin_tier_ads: props.isAds }" v-if="props.coinTierShown && tierProduct" @click="emit('handleShowProductPopup')">
      <img class="coin_tier_icon" src="~/assets/images/reader/icon-reader-coin-tier.svg" alt="">
      <div class="coin_tier_info">
        <p class="coin_tier_coins">{{ tierProduct.coin }} {{ $t('reader.coins') }}</p>
        <p class="coin_tier_price">${{ tierProduct.discount_price || tierProduct.price }}</p>
      </div>
      <div class="coin_tier_btn">{{ $t('reader.purchase') }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {defineProps, defineEmits, onMounted} from 'vue'
import {showToast} from 'vant'
import {useUserBalanceStore} from '~/stores/userBalance'
import {useLandDataStore} from "../../stores/land";
import {getRechargeProducts} from "../../utils/getRechargeProducts";
const userBalance = useUserBalanceStore()
const landDataStore = useLandDataStore()
const {t} = useI18n()
const emit = defineEmits(['handleShowProductPopup', 'unlockChapter'])
const props = defineProps({
  theme: {
    type: String,
    default: 'theme-light'
  },
  isAds: {
    type: Boolean,
    default: false
  },
  // V2.3.0 金币档位条显隐（页面在浮层/挽留关闭且未创建订单后置 true，进页默认 false）
  coinTierShown: {
    type: Boolean,
    default: false
  }
})
const isShow = ref(false)
const chapterId = ref('')
const unlockCoin = ref(0)
const isLoading = ref(false)
// 获取设备类型
const getDeviceType = () => {
  if (typeof window === 'undefined') return 'other'
  const UA = navigator.userAgent.toLowerCase()

  // iOS (iPhone, iPad, iPod)
  if (/iphone|ipad|ipod/i.test(UA)) {
    return 'ios'
  }
  // Mac OS
  if (/mac/i.test(UA) && !/iphone|ipad|ipod/i.test(UA)) {
    return 'mac'
  }
  // Android
  if (/android/i.test(UA)) {
    return 'android'
  }
  // Windows
  if (/win/i.test(UA)) {
    return 'windows'
  }
  return 'other'
}
const monetization = computed(() => {
  const deviceType = getDeviceType()
  // 优先从 store 获取
  let result = landDataStore.monetizationObj?.[deviceType]
  if (result !== undefined && result !== null) return result

  // 保底从 localStorage 缓存获取
  if (typeof window !== 'undefined') {
    try {
      const cached = localStorage.getItem('monetization')
      if (cached) {
        const parsed = JSON.parse(cached)
        if (parsed && parsed[deviceType] !== undefined) return parsed[deviceType]
      }
    } catch (e) {
      console.warn('读取 monetization 缓存失败', e)
    }
  }

  // 最终保底：ios 和 android 都返回 3（两者都展示）
  return 0
})

const showUnLockCard = (item: { chapter_id: string; unlock_coin: number }) => {
  userBalance.fetchBalance()
  isShow.value = true
  chapterId.value = item.chapter_id
  unlockCoin.value = item.unlock_coin
}

// V2.3.0 金币档位条数据：后台配置的第一个金币档位（一次性购买，排除挽留专用商品），无配置则不显示
const tierProduct = ref<any>(null)
watch(() => props.coinTierShown, async (shown) => {
  if (!shown || tierProduct.value) return
  try {
    const res: any = await getRechargeProducts(monetization.value)
    tierProduct.value = res?.data?.coin_products?.find((item: any) => item.retention_type === 0) || null
  } catch (e) {
    console.log('获取金币档位失败', e)
  }
})

const hideUnLockCard = () => {
  isShow.value = false
}

const showProductPopup = async () => {
  if (isLoading.value) return
  console.log('userBalance.balance', userBalance.balance)
  // 金币不足直接唤起充值弹窗
  if (userBalance.balance < unlockCoin.value) {
    emit('handleShowProductPopup')
    return
  }

  isLoading.value = true
  // 金币充足直接解锁
  const body = {
    chapter_id: chapterId.value
  }
  try {
    const res = await clientFetch('/api/reader/unlock-chapter', {
      method: 'POST',
      body
    })
    console.log('解锁章节', res)
    if (res.code === 0) {
      //   通知父组件请求该章节
      emit('unlockChapter', chapterId.value)
      //   解锁完成调用一下用户信息接口更新一下钱包余额
      userBalance.setBalance(res.data.wallet.balance_coin)
    } else if (res.code === 4006) {
      //   余额不足
      emit('handleShowProductPopup')
    } else {
      showToast(res.msg || t('reader.unlock_fail'))
    }
  } catch (e) {
    console.log('章节解锁', e)
  } finally {
    isLoading.value = false
  }
}

onMounted(() => {
})

defineExpose({
  showUnLockCard,
  hideUnLockCard
})
</script>

<style scoped lang="scss">
@import "~/assets/styles/theme.scss";

.unlock_card {
  width: 100%;
  //position: fixed;
  bottom: 0;
  //height: 416px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-left: 10px;
  padding-right: 10px;

  .gradient {
    width: 100%;
    height: 122px;
    background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0) 0%,
            var(--bg-color) 100%
    );
    position: absolute;
    top: -120px;
    z-index: 1;
  }

  .unlock_content {
    background: var(--bg-color);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    padding: 0 20px 21px;

    img {
      width: 33px;
      margin-top: 6px;
      margin-bottom: 8px;
    }

    span {
      font-family: Baloo2, Baloo2;
      font-weight: 600;
      font-size: 19px;
      color: var(--chapter-info-title-color);
      line-height: 30px;
      text-align: center;
      font-style: normal;
      margin-bottom: 9px;
    }

    p {
      font-family: 'SFPro', 'SFPro';
      font-weight: 400;
      font-size: 14px;
      color: var(--unlock-text-color);
      line-height: 20px;
      text-align: center;
      font-style: normal;
    }

    .unlock_btn {
      min-width: 312px;
      max-width: 400px;
      min-height: 47px;
      background: linear-gradient(90deg, #ff394d 0%, #ff398f 100%);
      border-radius: 23px;
      font-family: 'SFPro', 'SFPro';
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      font-style: normal;
      margin-bottom: 18px;
      margin-top: 30px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-left: 10px;
      padding-right: 10px;

      .point_img {
        position: absolute;
        right: 0;
        bottom: -35px;
        width: 57px;
        height: 57px;
      }

      .ads_badge {
        height: 25px;
        position: absolute;
        top: -22px;
        right: 0;

        img {
          width: 100%;
          height: 25px !important;
        }

        .ads_badge_off_text {
          font-family: 'SFPro', 'SFPro';
          font-weight: 600;
          font-size: 11px;
          color: #ffffff;
          line-height: 14px;
          text-align: center;
          font-style: normal;
          position: absolute;
          width: 100%;
          top: 10px;
        }
      }
    }

    .ads_p {
      font-family: 'SFPro', 'SFPro';
      font-weight: 500;
      font-size: 17px;
      color: #8b4300;
      line-height: 23px;
      text-align: center;
      font-style: normal;
    }
  }

  // V2.3.0 金币档位条（Moonvy: 阅读器解锁页-内购金币，750 稿标注 ÷2）
  .coin_tier {
    width: 100%;
    height: 75px;
    background: linear-gradient(90deg, #FFE6C4 0%, #FFEED8 50%, #FFD9AB 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    padding: 0 15px;
    // 设计稿文字底到档位条间距 30px，unlock_content 自带 padding-bottom 21px，这里补 9px
    margin-top: 9px;
    // ads 落地页分支最后元素是按钮（自带 margin-bottom 18px），回缩保持 30px 视觉间距
    &.coin_tier_ads {
      margin-top: -9px;
    }
    cursor: pointer;

    .coin_tier_icon {
      width: 27px;
      height: 27px;
    }

    .coin_tier_info {
      margin-left: 10px;

      .coin_tier_coins {
        font-family: 'SFPro', 'SFPro';
        font-weight: 600;
        font-size: 16px;
        line-height: 19px;
        color: #5a2b00;
      }

      .coin_tier_price {
        font-family: 'SFPro', 'SFPro';
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        color: #9b6c41;
        margin-top: 3px;
      }
    }

    .coin_tier_btn {
      margin-left: auto;
      width: 82px;
      height: 30px;
      background: linear-gradient(90deg, #8F4C10 0%, #66351A 100%);
      border-radius: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: 'SFPro', 'SFPro';
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      color: #fde5c8;
    }
  }
}
</style>
